(function (root) {
  function availableYears(data, make, model) {
    const years = new Set();
    let hasUnspecified = false;
    for (const r of data.fitments.filter(r => r.make === make && r.models.includes(model))) {
      const start = r.start?.year, end = r.end?.year;
      if (start && end && start <= end) {
        for (let year = start; year <= end; year++) years.add(year);
      } else {
        hasUnspecified = true;
        if (start) years.add(start);
        if (end) years.add(end);
      }
    }
    return { years: [...years].sort((a,b) => b-a), hasUnspecified };
  }
  function assess(data, choice) {
    if (!choice.make || !choice.model || !choice.year) return [];
    const unspecified = choice.year === 'unspecified';
    const year = Number(choice.year), month = Number(choice.month) || null;
    const lo = year * 12 + (month || 1), hi = year * 12 + (month || 12);
    const candidates = data.fitments.filter(r => {
      if (r.make !== choice.make || !r.models.includes(choice.model)) return false;
      if (unspecified) return !r.start?.year || !r.end?.year;
      const start = r.start?.year ? r.start.year * 12 + (r.start.month || 1) : null;
      const end = r.end?.year ? r.end.year * 12 + (r.end.month || 12) : null;
      return !(start !== null && hi < start || end !== null && lo > end);
    });
    const parts = new Set(candidates.map(r => r.mpn));
    return candidates.map(r => {
      const reasons = r.flags.filter(f => f !== 'overlapping_parts');
      if ([r.start,r.end].some(d => d?.year === year && d.month) && !month) reasons.push('choose_month');
      if (parts.size > 1) reasons.push('multiple_parts');
      return { ...r, reasons: [...new Set(reasons)], sourceMatch: reasons.length === 0 };
    });
  }
  const api = { assess, availableYears };
  if (typeof module !== 'undefined') module.exports = api;
  root.HubEngine = api;
})(typeof window !== 'undefined' ? window : globalThis);
